import { theme, Tooltip } from 'antd'
import type { TooltipProps } from 'antd'
import { Info } from 'lucide-react'
import type { LucideProps } from 'lucide-react'

const ICON_SIZE = 14

type IconProps = LucideProps & Record<`data-${string}`, string>

type Props = {
  iconProps?: IconProps
  optimized?: boolean
} & TooltipProps

export const InfoTooltip = ({
  iconProps,
  optimized = false,
  ...props
}: Props) => {
  const { token } = theme.useToken()

  const icon = (
    <Info
      size={ICON_SIZE}
      color={token.colorTextQuaternary}
      style={{ flexShrink: 0, cursor: 'help' }}
      {...iconProps}
    />
  )

  if (optimized) {
    return (
      <span title={typeof props.title === 'string' ? props.title : undefined}>
        {icon}
      </span>
    )
  }

  return <Tooltip {...props}>{icon}</Tooltip>
}
